import TableWidget from "../../../components/tables/TableWidget";
import { TableActions } from "../../../components/tables/tableContext/TableContext";

import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { getReceivedProducts } from "../../../redux/api/inventory.api";

import {
  getInventoryTableData,
  inventoryTableHeader,
} from "./tableConfigs/inventoryTableConfig";
import TotalReceivedProductsHeader from "./components/TotalReceivedProductsHeader";

function TotalReceivedProducts() {
  const dispatch = useAppDispatch();

  const {
    inventory: {
      receivedProducts: {
        data: { data: receivedProductsData, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    inventory: state.inventory,
  }));

  const handleTableActions = (action: TableActions) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      if (action.tableSearch.startDate && action.tableSearch.endDate) {
        dispatch(
          getReceivedProducts({
            page: action.tablePagination.page,
            per_page: action.tablePagination.rowsPerPage,
            startDate: action.tableSearch.startDate,
            endDate: action.tableSearch.endDate,
            numeProdus: action.tableSearch?.numeProdus,
            numeFurnizor: action.tableSearch?.numeFurnizor,
            lot: action.tableSearch?.lot,
          }),
        );
      }
    }
  };

  return (
    <TableWidget
      tableTitle="Total produse receptionate"
      tableHeaderData={inventoryTableHeader}
      tableItemsData={getInventoryTableData(receivedProductsData)}
      tableLoading={isLoading}
      handleTableActions={handleTableActions}
      totalItems={total}
      CustomHeaderComponent={TotalReceivedProductsHeader}
    />
  );
}

export default TotalReceivedProducts;
